/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NewRole
 */
export interface NewRole {
    /**
     * 
     * @type {string}
     * @memberof NewRole
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NewRole
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof NewRole
     */
    created?: Date;
    /**
     * 
     * @type {Date}
     * @memberof NewRole
     */
    modified?: Date;
}

/**
 * Check if a given object implements the NewRole interface.
 */
export function instanceOfNewRole(value: object): value is NewRole {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function NewRoleFromJSON(json: any): NewRole {
    return NewRoleFromJSONTyped(json, false);
}

export function NewRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewRole {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'created': json['created'] == null ? undefined : (new Date(json['created'])),
        'modified': json['modified'] == null ? undefined : (new Date(json['modified'])),
    };
}

export function NewRoleToJSON(json: any): NewRole {
    return NewRoleToJSONTyped(json, false);
}

export function NewRoleToJSONTyped(value?: NewRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'created': value['created'] == null ? undefined : ((value['created']).toISOString()),
        'modified': value['modified'] == null ? undefined : ((value['modified']).toISOString()),
    };
}

